import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';

import { formatNumber } from '../../../helpers';

const getColumnChartOptions = (id, categories, yFormatter, tooltipTitle = '') => ({
  chart: {
    id,
    toolbar: {
      tools: {
        download: false,
      },
    },
    height: '100%',
  },
  colors: ['#28c29b'],
  xaxis: {
    categories,
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    show: false,
  },
  plotOptions: {
    bar: {
      columnWidth: '20%',
      borderRadius: 3,
      borderRadiusApplication: 'end',
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    y: {
      formatter: yFormatter,
      title: {
        formatter: () => (tooltipTitle),
      },
    },
    marker: {
      show: false,
    },
  },
  states: {
    hover: {
      filter: {
        type: 'darken',
        value: 0.85,
      },
    },
  },
});

const AdminReportsCartBar = ({ report, data, fullPage }) => (
  <Chart
    options={getColumnChartOptions(
      report.id,
      data.map(d => (d.period)),
      formatNumber,
      report.tooltipTitle,
    )}
    series={[{
      name: report.id,
      data: data.map(d => (d.count)),
    }]}
    type="bar"
    width="100%"
    height={fullPage ? 400 : 300}
  />
);

AdminReportsCartBar.propTypes = {
  report: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  fullPage: PropTypes.bool,
};

AdminReportsCartBar.defaultProps = {
  fullPage: false,
};

export default AdminReportsCartBar;
